import { render, staticRenderFns } from "./systemMessages.vue?vue&type=template&id=2876666e&scoped=true&"
import script from "./systemMessages.vue?vue&type=script&lang=js&"
export * from "./systemMessages.vue?vue&type=script&lang=js&"
import style0 from "./systemMessages.vue?vue&type=style&index=0&id=2876666e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2876666e",
  null
  
)

export default component.exports